import { render, staticRenderFns } from "./Mckinney.vue?vue&type=template&id=8b074162&lang=pug&"
import script from "./Mckinney.vue?vue&type=script&lang=ts&"
export * from "./Mckinney.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports